module.exports = __webpack_public_path__ + "assets/img/transparency-5.24c29d02.svg";